import { render, staticRenderFns } from "./SettlementDay.vue?vue&type=template&id=80823c7e&"
import script from "./SettlementDay.vue?vue&type=script&lang=ts&"
export * from "./SettlementDay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports